import React, { useEffect, useState } from 'react'
import TableActionsWrapper from 'components/Wrapper/TableActionsWrapper';
import TableSearchWrapper from 'components/Wrapper/TableSearchWrapper';
import TableWrapper from 'components/Wrapper/TableWrapper';
import ProgressLoader from 'components/Loader/ProgressLoader';
import TablePagingWrapper from 'components/Wrapper/TablePagingWrapper';
import TablePagination, { pageOptions } from 'components/Paginate/TablePagination';
import { Button, Card, Col, Form, FormCheck, OverlayTrigger, Row, Table, Tooltip } from 'react-bootstrap'
import { InfoCircle, List, PencilSquare, Plus, Trash } from 'react-bootstrap-icons';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { apiUrls } from 'constants/apiUrls';
import { customerService } from 'services/customerService';
import { appRoutesUrls } from 'constants/appRoutesUrls';
import { toDDMMYYYYHHMMSS } from 'utils/dateFormatter';
import { deleteOnConfirm } from 'components/Confirm/ConfirmDialog';
import { allowNumber } from 'utils/inputValidator';
import { ButtonExportCsv, ButtonExportExcel, ButtonReset, ButtonSearch } from 'components/Buttons/Buttons';
import { BiFilterAlt } from 'react-icons/bi';
import { AnimatePresence, motion } from "framer-motion"

const CustomerList = () => {
    const navigate = useNavigate();
    const [customers, setCustomers] = useState();
    const [isLoader, setIsLoader] = useState(false);
    const [showMore, setShowMore] = useState(false);
    const [showFilter, setShowFilter] = useState(true);
    const initialFilters = {
        currentPage: pageOptions.currentPage,
        pageSize: pageOptions.pageSize,
        orderBy: 'id asc',
        name: '',
        mobileNo: '',
        gstIn: '',
        isAmountDue: null,
        isActive: true
    };
    const [filters, setFilters] = useState(initialFilters);

    useEffect(() => {
        getCustomers(filters);
    }, [])

    const getCustomers = (filters) => {
        setIsLoader(true);
        customerService.getCustomers(apiUrls.getCustomers(), filters).then(res => {
            setIsLoader(false);
            setCustomers(res);
        }).catch((err) => setIsLoader(false));
    }

    const deleteCustomer = (id) => {
        setIsLoader(true);
        customerService.deleteCustomer(apiUrls.deleteCustomer(id)).then(res => {
            setIsLoader(false);
            if (res === true) {
                toast.info("Customer deleted successfully!");
                getCustomers(filters);
            }
        }).catch((err) => setIsLoader(false));
    }

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;

        if (name === "mobileNo" && !allowNumber(e.target.value)) { return; }

        setFilters((preValue) => ({
            ...preValue, [name]: (type === 'checkbox' ? checked : value)
        }));
    }

    const handleSearch = (e) => {
        let searchFilters = { ...filters, currentPage: 1 }
        setFilters(searchFilters);
        getCustomers(searchFilters);
    }

    const handleReset = (e) => {
        setFilters(initialFilters);
        getCustomers(initialFilters);
    }

    // const handleOrderByClick = (e) => {
    //     let pageFilters = { ...filters, currentPage: (e.selected + 1) }
    //     setFilters(pageFilters);
    //     getCustomers(pageFilters);
    // }

    const handlePageClick = (e) => {
        let pageFilters = { ...filters, currentPage: (e.selected + 1) }
        setFilters(pageFilters);
        getCustomers(pageFilters);
    }

    const handlePageSizeChange = (e) => {
        let pageFilters = { ...filters, pageSize: e.target.value, currentPage: pageOptions.currentPage }
        setFilters(pageFilters);
        getCustomers(pageFilters);
    }

    const handleExport = (option) => {
        alert(option);
    }

    return (
        <>
            {isLoader && <ProgressLoader />}
            <Card className='card-default'>
                <Card.Body>
                    <Card.Title>
                        <List size={24} /> Customers {customers && `(${customers?.totalItems})`}
                        <BiFilterAlt size={24} className='float-end hand'
                            color={(showFilter ? '#0d6efd' : '#6c757d')}
                            onClick={() => setShowFilter(!showFilter)} />
                    </Card.Title>
                    <AnimatePresence>
                        {showFilter && (
                            <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}>
                                <TableSearchWrapper>
                                    <Form noValidate>
                                        <Row>
                                            <Col md={3}>
                                                <Form.Control
                                                    type="text"
                                                    placeholder="Customer Name"
                                                    name='name'
                                                    value={filters.name}
                                                    onChange={handleChange}
                                                    maxLength={20}
                                                    className="mb-2" />
                                            </Col>
                                            <Col md={2}>
                                                <Form.Control
                                                    type="text"
                                                    placeholder="Mobile No"
                                                    name='mobileNo'
                                                    value={filters.mobileNo}
                                                    onChange={handleChange}
                                                    maxLength={10}
                                                    className="mb-2" />
                                            </Col>
                                            <Col md={2}>
                                                <Form.Control
                                                    type="text"
                                                    placeholder="GSTIN"
                                                    name='gstIn'
                                                    value={filters.gstIn}
                                                    onChange={handleChange}
                                                    maxLength={10}
                                                    className="mb-2" />
                                            </Col>
                                            <Col md={2}>
                                                <Form.Check
                                                    type="checkbox"
                                                    name='isAmountDue'
                                                    checked={filters.isAmountDue}
                                                    onChange={handleChange}
                                                    label="Due Amt Only"
                                                    className='mb-2' />
                                            </Col>
                                            <Col md={1} sm={6}>
                                                <Form.Check
                                                    type="checkbox"
                                                    name='isActive'
                                                    checked={filters.isActive}
                                                    onChange={handleChange}
                                                    label="Active"
                                                    className='mb-2'
                                                />
                                            </Col>
                                            <Col md={2} sm={6} className="text-right">
                                                <ButtonSearch onClick={handleSearch} />
                                                <ButtonReset onClick={handleReset} />
                                            </Col>
                                        </Row>
                                    </Form>
                                </TableSearchWrapper>
                            </motion.div>
                        )}
                    </AnimatePresence>
                    <TableActionsWrapper>
                        <Row className='mt-1'>
                            <Col sm={8}>
                                <Button
                                    size="sm"
                                    type="button"
                                    variant="primary"
                                    className='mw-100'
                                    onClick={() => navigate(appRoutesUrls.customerAdd())}>
                                    <Plus size={24} /> Customer
                                </Button>
                            </Col>
                            <Col sm={4} className='text-right'>
                                <ButtonExportExcel onClick={() => handleExport('excel')} />
                                <ButtonExportCsv onClick={() => handleExport('csv')} />
                                <FormCheck
                                    type="switch"
                                    className='ms-2 float-end'
                                    label=""
                                    onChange={() => setShowMore(!showMore)}
                                    title={`Show ${showMore ? 'Less' : 'More'} Columns`}
                                />
                            </Col>
                        </Row>
                    </TableActionsWrapper>
                    <TableWrapper>
                        <Table striped hover responsive bordered>
                            <thead>
                                <tr>
                                    <th className='col-action-120'>Action</th>
                                    <th style={{ width: '50px' }}>ID&nbsp;</th>
                                    <th style={{ width: '250px' }}>Customer Name</th>
                                    <th>Invoices</th>
                                    <th>Invoice Items</th>
                                    <th style={{ width: '250px' }}>Address</th>
                                    <th style={{ width: '150px' }}>Email</th>
                                    <th>Mobile No</th>
                                    <th>GSTIN</th>
                                    <th className='text-right'>Due Amt.</th>
                                    {showMore && (
                                        <>
                                            <th>Added Date</th>
                                            <th>Added By</th>
                                            <th>Modified Date</th>
                                            <th>Modified By</th>
                                        </>
                                    )}
                                </tr>
                            </thead>
                            <tbody>
                                {customers?.items && customers?.items.map((customer, i) => (
                                    <tr key={i}>
                                        <td>
                                            <Button
                                                as={Link}
                                                size='sm'
                                                variant="primary"
                                                className='btn-action ms-1'
                                                to={appRoutesUrls.customerView(customer.id)}>
                                                <InfoCircle />
                                            </Button>
                                            <Button
                                                as={Link}
                                                size='sm'
                                                variant="secondary"
                                                className='btn-action ms-1'
                                                to={appRoutesUrls.customerEdit(customer.id)}>
                                                <PencilSquare />
                                            </Button>
                                            {customer.isActive && (
                                                <Button
                                                    size='sm'
                                                    variant="danger"
                                                    className='btn-action ms-1'
                                                    onClick={() => deleteOnConfirm(customer.id, deleteCustomer, null)}>
                                                    <Trash />
                                                </Button>
                                            )}
                                        </td>
                                        <td>{customer.id}</td>
                                        <td onClick={() => navigate(appRoutesUrls.customerView(customer.id))} className="hand">
                                            {customer.name}
                                        </td>
                                        <td>
                                            <Button
                                                size='sm'
                                                variant="outline-primary"
                                                className='btn-action text-bold mw-80'
                                                onClick={() => navigate(appRoutesUrls.customerInvoices(customer.id))}
                                                disabled={!customer.isActive}>
                                                {customer.invoices}
                                            </Button>
                                        </td>
                                        <td>
                                            <Button
                                                size='sm'
                                                variant="outline-warning"
                                                className='btn-action text-bold mw-80'
                                                onClick={() => navigate(appRoutesUrls.customerInvoiceItems(customer.id))}
                                                disabled={!customer.isActive}>
                                                {customer.pendingInvoiceItems}
                                            </Button>
                                        </td>
                                        <td>
                                            {customer.address.length > 50 ?
                                                <>
                                                    <OverlayTrigger
                                                        placement="top"
                                                        delay={{ show: 250, hide: 400 }}
                                                        overlay={(<Tooltip id="button-tooltip">{customer.address}</Tooltip>)}>
                                                        <Button size="sm" variant="default">
                                                            {customer.address.substring(0, 50)} ...
                                                        </Button>
                                                    </OverlayTrigger>
                                                </> :
                                                <>{customer.address}</>
                                            }
                                        </td>
                                        <td>{customer.email}</td>
                                        <td>{customer.mobileNo}</td>
                                        <td>{customer.gstIn}</td>
                                        <td align='right'>
                                            <b className={(customer.invoicesBalance > 0 ? 'text-danger' : 'text-success')}>
                                                {customer.invoicesBalance}
                                            </b>
                                        </td>
                                        {showMore && (
                                            <>
                                                <td>{toDDMMYYYYHHMMSS(customer.addedDate)}</td>
                                                <td>{customer.addedBy}</td>
                                                <td>{toDDMMYYYYHHMMSS(customer.modifiedDate)}</td>
                                                <td>{customer.modifiedBy}</td>
                                            </>
                                        )}
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    </TableWrapper>
                    <TablePagingWrapper>
                        <TablePagination
                            pageSize={filters.pageSize}
                            currentPage={filters.currentPage}
                            totalPages={customers?.totalPages}
                            totalItems={customers?.totalItems}
                            onPageChange={handlePageClick}
                            onPageSizeChange={handlePageSizeChange}
                            pageTitle="Customers"
                        />
                    </TablePagingWrapper>
                </Card.Body>
            </Card>
        </>
    )
}

export default CustomerList;